import { render, staticRenderFns } from "./editTxt2Dialog.vue?vue&type=template&id=67bef204&scoped=true"
import script from "./editTxt2Dialog.vue?vue&type=script&lang=js"
export * from "./editTxt2Dialog.vue?vue&type=script&lang=js"
import style0 from "./editTxt2Dialog.vue?vue&type=style&index=0&id=67bef204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bef204",
  null
  
)

export default component.exports